import { BASE_URL } from "../../config";
import { getAccessToken } from "../../utils/accessToken";

export async function streamOpenAiExplanation({ storyJson, followUpPrompt = "", messages = [], onDelta }) {
    const token = getAccessToken();
    const response = await fetch(`${BASE_URL}observability/ai-explain/stream`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({
            story_json: storyJson || {},
            follow_up_prompt: followUpPrompt || "",
            messages: (messages || []).map((item) => ({
                role: item.role === "assistant" ? "assistant" : "user",
                content: String(item.content || ""),
            })),
            language: "en",
        }),
    });

    if (!response.ok) {
        const body = await response.text();
        throw new Error(`AI explain error ${response.status}: ${body.slice(0, 220)}`);
    }

    if (!response.body) {
        throw new Error("Streaming body is not available in this browser.");
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";

    while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        if (buffer) {
            onDelta(buffer);
            buffer = "";
        }
    }
}
